import { render, staticRenderFns } from "./TreeMapCost.vue?vue&type=template&id=23b8802e"
import script from "./TreeMapCost.vue?vue&type=script&lang=js"
export * from "./TreeMapCost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports